<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      validation-provider(name="nombre" rules="required|max:50|alpha_spaces" v-slot="{ errors }")
        v-text-field(
          :value="data.firstName"
          :error-messages="errors"
          :disabled="disabled"
          name="nombre"
          @input="onInputName"
        )
      div(:class="b('toc-disclaimer')") Al "Registrarte", aceptas nuestros #[a(href="https://rebajatuscuentas.com/mx/politicas-de-privacidad" target="_blank") Términos y Condiciones y Políticas de usos de Datos.]
</template>

<script>
  import formMixin from '@/mixins/form-mixin';

  const DEFAULT_VALUES = {
    firstName: null,
  };

  export default {
    name: 'customer-form-4',

    mixins: [
      formMixin(),
    ],

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },

    methods: {
      onInputName(name) {
        if(name && name.length) this.data.firstName = name[0].toUpperCase() + name.substr(1);
      },
    }
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0

    &__toc-disclaimer
      padding-top: 6px
      font-size: 14px
      font-style: italic
</style>